<app-liste-bdc [listeBdc]="listeBdc" [tableId]="'listeInterventions'" [datatables]="true"
              [colonnes]="'id no_bdc client prix piece_a_commander_commentaire status'"></app-liste-bdc>

